import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { StatusLabel } from '@shared/components/StatusLabel';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle.hook';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import SignInContext from '@modules/users/contexts/SignInContext.context';
import { useFolder } from '@modules/items/api/folders.api';
import { isTFolder } from '@modules/items/types/folders.types';
import ChangeTemplatesContent from '../components/ChangeTemplatesContent';
import { isChangeTemplatesEnabled } from '../helpers';

const ChangeTemplates = () => {
  const { organization } = useContext(SignInContext);
  const enabled = isChangeTemplatesEnabled(organization);
  useDocumentTitle(TERMINOLOGY.changeTemplate.upperPlural);
  // Change Templates live under QM, so QM drives the nav drawer and breadcrumbs.
  const { data: qmData, error: qmError } = useFolder(organization.folders.qm, { enabled });
  // The hidden root's access right gates the actions.
  const { data: rootData, error: rootError } = useFolder(organization.folders.changeTemplates, { enabled });
  const qmFolder = qmData && isTFolder(qmData) ? qmData : undefined;
  const rootFolder = rootData && isTFolder(rootData) ? rootData : undefined;

  if (!enabled) return <Navigate to="/" replace />;

  return (
    <StatusLabel
      data={qmFolder && rootFolder ? { qmFolder, rootFolder } : undefined}
      error={qmError ?? rootError}
      loadingMessage="Loading workspace..."
      errorMessage="Loading workspace failed!"
      render={(resolved) => <ChangeTemplatesContent {...resolved} />}
    />
  );
};

export default ChangeTemplates;
